import { render, staticRenderFns } from "./NewCampaignStep2.vue?vue&type=template&id=4b611c50&scoped=true&"
import script from "./NewCampaignStep2.vue?vue&type=script&lang=js&"
export * from "./NewCampaignStep2.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaignStep2.vue?vue&type=style&index=0&id=4b611c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b611c50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VForm,
  VLayout,
  VTextField,
})
